import React, { useEffect, useState } from 'react'
import { css } from '@emotion/core'
import { colors, Icon, Spinner, Table, Typography } from '@dw/helix'
import { API } from '../../utils/api'
import { PurchaseOrder } from './GenerateSerialNumbersPage'

const purchaseOrderPanelStyles = css`
  background-color: #fff;
  padding: 0 21px 42px;
  border-radius: 2px;
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.19), 0 3px 3px 0 rgba(0, 0, 0, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const panelHeadingStyles = css`
  margin-top: 20px;
  margin-bottom: 19.8px;
`

const closeButtonStyles = css`
  position: absolute;
  box-sizing: content-box;
  width: 15px;
  height: 15px;
  padding: 10px;
  top: 13px;
  right: 10px;
  background-color: transparent;
  border: 0;
  display: flex;
  svg {
    fill: ${colors.brandBlue};
  }
`

const tableStyles = css`
  width: 100%;
`

interface PONumberSerialsInformationProps {
  purchaseOrder: PurchaseOrder
  onClose: () => any
}

interface PONumberArticle {
  orderNo: string
  batchNo: string
  articleNo: string
  processed: number
  startSerial: number
  qty: number
  status: string
  serialNo: string
  endSerial: number
}

const PONumberSerialsInformation: React.FunctionComponent<PONumberSerialsInformationProps> = props => {
  const [articles, setArticles] = useState<PONumberArticle[]>([])
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const fetchBatch = async () => {
      setIsLoading(true)
      try {
        const orderNo = props.purchaseOrder.orderId
        const response = await API.get('its-batches', `/batches/orderNo/${orderNo.toUpperCase()}`, {})
        setArticles(response.items)
        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
        throw e
      }
    }
    fetchBatch()
  }, [props.purchaseOrder])
  return (
    <div css={purchaseOrderPanelStyles}>
      <Typography type="h4" css={panelHeadingStyles}>
        Purchase order {props.purchaseOrder.orderId}
      </Typography>
      <button type="button" onClick={props.onClose} css={closeButtonStyles}>
        <Icon name="close" />
      </button>
      <Table
        items={articles}
        columns={[
          { label: 'Art. No', field: 'articleNo', width: '137px' },
          {
            label: 'Serial Numbers',
            render: ({ startSerial, endSerial }) => `${startSerial}-${endSerial}`,
            width: '225px',
          },
          { label: 'Batch Number', field: 'batchNo', width: '124px' },
        ]}
        rowKey={'articleNo'}
        css={tableStyles}
      />
      {isLoading && (
        <Spinner
          color={colors.brandBlue}
          css={css`
            padding: 10px;
          `}
        />
      )}
    </div>
  )
}

export default PONumberSerialsInformation
